export default {"src":"/_next/static/media/flag_switch_en.e949ce9b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};